export default __webpack_public_path__ + "static/media/file_example_MP3_1MG.006bd74b.mp3";